<template>
    <rect fill="#fff"
          width="9"
          height="2"></rect>
    <rect fill="#0039a6"
          y="2"
          width="9"
          height="2"></rect>
    <rect fill="#d52b1e"
          y="4"
          width="9"
          height="2"></rect>
</template>
